export const editContract = [
  {
    title: "Guía práctica para editar tu contrato inteligente antes de desplegarlo en Blockchain",
    value: `
Antes de desplegar tu propio contrato inteligente en la red Blockchain (Ethereum, Polygon u otra compatible), sigue estos pasos de preparación y personalización:

---

**Preparación inicial:**  
En esta lección, editaremos el contrato inteligente para adaptarlo a tu proyecto y poder emitirlo en la Blockchain.  
Tener todo listo te ayudará a trabajar más rápido y evitar errores durante la edición y el despliegue.

---

1. **Contrato del activo a tokenizar (ejemplo: bienes raíces)**  
   Consigue el contrato legal del activo que deseas tokenizar.  
   En este ejemplo usamos un contrato de bienes raíces (por ejemplo, un PDF ya proporcionado), pero puedes utilizar la información de cualquier activo: empresa, arte, derechos, etc.  
   **Puedes descargar el PDF de ejemplo aquí:**  
   [Descargar Real-estate+Asset+Contract+Example.pdf](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/Real-estate+Asset+Contract+Example.pdf)  
   Reemplaza los datos del ejemplo por los de tu propio activo.

2. **Dirección de tu wallet**  
   Ten a la mano la dirección de tu billetera (wallet), la cual creaste en MyEtherWallet, MetaMask u otra plataforma.  
   Esta dirección será la que reciba todos los tokens generados en el despliegue inicial de tu contrato inteligente.

3. **Editor de texto con el contrato base**  
   Abre tu editor de texto favorito (Sublime Text, VS Code, o Remix IDE en el navegador).  
   Asegúrate de cargar la plantilla del contrato inteligente que obtuviste previamente desde GitHub o una fuente confiable.  
   Así tendrás todo listo para comenzar a personalizar nombre, símbolo, cantidad total y demás parámetros técnicos.

---

**¿Debes agregar imágenes?**  
**Sí, es altamente recomendable agregar imágenes** durante tu proceso y documentación, especialmente si:

- **Explicas el paso a paso:** Puedes mostrar capturas de pantalla de la plantilla, del editor de texto, de la wallet, etc.
- **Vas a compartir la guía con otros:** Las imágenes ayudan a comprender mejor cada parte del flujo.
- **Documentas el contrato o el activo:** Una imagen del contrato legal, del inmueble, del PDF original o de la wallet ayuda a validar y visualizar el proceso.

Recuerda: las imágenes hacen tu documentación mucho más clara y accesible para principiantes y futuros auditores.

---

¡Listo! Ahora sigue con la edición personalizada de tu contrato para tu proyecto.
`
  }
];

export default editContract;
